import { connect } from 'react-redux';
import {
  getRetentionComplexExecutedQuery,
  getRetentionComplexExecuteTime,
  getRetentionComplexExecutionResult,
  getRetentionComplexOptions,
} from '../../../reducers/analyticsApp';
import RetentionResult from '../../../components/retention/RetentionResult';

const mapStateToProps = (state) => {
  const executedQuery = getRetentionComplexExecutedQuery(state);

  return {
    result: getRetentionComplexExecutionResult(state),
    timezone: executedQuery ? executedQuery.timezone : null,
    dimensionType: executedQuery ? executedQuery.sequence.type : null,
    sequence: executedQuery ? executedQuery.sequence.units : null,
    executeTime: getRetentionComplexExecuteTime(state),
    options: getRetentionComplexOptions(state),
    executedQuery,
  };
};

export default connect(mapStateToProps)(RetentionResult);
